import { Box, Dialog, Grid, Typography } from "@mui/material";
import LockerAuthenticationForm from "./LockerAuthenticationForm";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { UserAuthenticationSchema } from "../../../../components/utility/yupValidation/VisitLogsValidations";
import { useNavigate } from "react-router-dom";
import { CheckInCheckOut } from "../CheckInCheckOut";
import moment from "moment";
import { closeFingerTemplate } from "../../../../components/biometric/closeFingerPrint";
import { useState } from "react";

const LockerAuthentication = ({ fingerControl, open, setOpen, refetch, state, setState }: { fingerControl: any, refetch: any, open: boolean, setOpen: (value: any) => any, state: any, setState: any }) => {
    const initialValues = { lockerNumber: "", customerId: "", passCode: "", fingerTemplate: "" }
    const [isBlur, setIsBlur] = useState(false)

    const { handleSubmit, control, formState: { errors }, setValue, watch, getValues, reset } = useForm({
        resolver: yupResolver(UserAuthenticationSchema),
        defaultValues: initialValues
    });

    const navigate = useNavigate();

    const handleClose = () => {

        if (state?.opId) {
            closeFingerTemplate(state, setState)
        }
        reset()
        setOpen(false);
    }

    const onCapture = (data: any) => {
        const parsedTime = moment(data?.checkinTime, 'hh:mm A').toDate().getTime();
        navigate(`/visit-logs/user-verification/${data?.customerId}/${parsedTime}`);
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            fullWidth={false}
            maxWidth="xl"
        >
            <Grid container gap={5} sx={{ padding: "40px 40px", minWidth: "600px" }}>
                <Box sx={{ width: '300px', display: 'flex', alignItems: 'center', justifyContent: ' center' }} >
                    <LockerAuthenticationForm setIsBlur={setIsBlur} state={state} reset={reset} handleClose={handleClose} handleSubmit={handleSubmit} setValue={setValue} getValues={getValues} control={control} errors={errors} watch={watch} />
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', "&::before": { content: '""', position: 'absolute', top: '50px', height: '85px', width: '1px', background: '#e7e7e7' }, "&::after": { content: '""', position: 'absolute', bottom: '50px', height: '85px', width: '1px', background: '#e7e7e7' }, position: "relative" }}>
                    <Typography sx={{ color: 'gray' }}>or</Typography>
                </Box>
                <Box sx={{ width: '300px', display: 'flex', alignItems: 'center', justifyContent: ' center' }} >
                    <Box sx={{ width: "100%", height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-around' }}>
                        <Typography component="h5" sx={{ color: "black", fontWeight: "600", fontSize: "20px" }} align="center">
                            Biometric
                        </Typography>

                        <CheckInCheckOut setIsBlur={setIsBlur} isBlur={isBlur} fingerControl={fingerControl} handleSubmit={handleSubmit} onCapture={onCapture} inputType={'checkIn'} refetch={refetch} state={state} setState={setState} />

                    </Box>
                </Box>
            </Grid >
        </Dialog >
    );
}

export default LockerAuthentication;
